import React from 'react';

import { HelpSidebarCustom } from './Custom';
import { HelpSidebarOnboarding } from './Onboarding';
import { HelpSidebarRoles } from './Roles';
import { HelpSidebarRootEntity } from './RootEntity';
import { HelpSidebarSupport } from './Support';

export const helpSidebars = [
  <HelpSidebarOnboarding key="HelpSidebarOnboarding" />,
  <HelpSidebarSupport key="HelpSidebarSupport" />,
  <HelpSidebarCustom key="HelpSidebarCustom" />,
  <HelpSidebarRoles key="HelpSidebarRoles" />,
  <HelpSidebarRootEntity key="HelpSidebarRootEntity" />,
];
